
import { Injectable } from '@angular/core';
import { v4 } from 'uuid';
import { DesktopStorageService } from './storage.service';
import { AbstractUUIDService } from 'huddyapi';


@Injectable({
  providedIn: 'root'
})
export class UUIDService extends AbstractUUIDService{

  iosUniqueDeviceID: string;

  constructor( private storage: DesktopStorageService ) {
    super();
  }

  getUuidV4String() {
    return v4.UUID();
  }

  async getUUID(): Promise<string> {
    let uuid: string;
    await this.storage.get('deviceUUID').then((savedUUID: string) => {
      uuid = savedUUID;
    }, (error: any) => {
      //do nothing
    });
    if(uuid != null)
      return uuid;
    const result = v4 ? this.getUuidV4String() : UUIDService.generateUUID();
    this.storage.set('deviceUUID', result);
    return result;
  }

  static generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  };

}
